import { inject, observer } from "mobx-react";
import LoaderComponent from "../../components/shared/LoaderComponent/LoaderComponent";

const Loader = inject('sharedStore')(observer(LoaderComponent));

export default Loader;